import { formatInUserTimezone } from './timezone';

// ============================================================
// COMMON FORMATTERS - Complete File
// ============================================================

// ============================================================
// NAMED EXPORTS (for direct import: import { formatFileSize } from './formatters')
// ============================================================

export const formatFileSize = (bytes) => {
  if (bytes === 0 || bytes === null || bytes === undefined || bytes === '') return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const formatDate = (date) => {
  if (!date) return 'N/A';
  const formatted = formatInUserTimezone(date);
  if (formatted === 'N/A') return 'N/A';
  return formatted.replace(/\s+\d{1,2}:\d{2}\s+[AP]M$/, '');
};

export const formatDateTime = (date) => {
  return formatInUserTimezone(date);
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount || 0);
};

export const formatPhone = (phone) => {
  if (!phone) return 'N/A';
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0,3)}) ${cleaned.slice(3,6)}-${cleaned.slice(6,10)}`;
  }
  return phone;
};

export const truncate = (text, length = 50) => {
  if (!text) return '';
  if (text.length <= length) return text;
  return text.slice(0, length) + '...';
};

export const getInitials = (name) => {
  if (!name) return 'U';
  const parts = name.split(' ');
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

// ============================================================
// DEFAULT EXPORT (for: import formatters from './formatters')
// ============================================================

const formatters = {
  formatFileSize,
  formatDate,
  formatDateTime,
  formatCurrency,
  formatPhone,
  truncate,
  getInitials
};

export default formatters;